import { ReactNode } from 'react';

export const separateContent = ({
  htmlContent,
  textSeparator,
  maxItems,
}: {
  htmlContent: string | ReactNode[];
  textSeparator: string;
  maxItems: number;
}) => {
  let first, second, isTwoParts, isArray;

  if (Array.isArray(htmlContent)) {
    // Если контент - это список
    first = htmlContent.slice(0, maxItems);
    second = htmlContent.slice(maxItems);
    isTwoParts = second.length > 0;
    isArray = true;
  } else {
    // Если контент - это текст
    // Тут на всякий случай проверяем, что контент есть и он разбиваем на две части.
    // Если это не так, то мы не должны поломать вывод информации и должны просто вывести все как есть
    const parts = htmlContent && htmlContent?.split(textSeparator);
    isTwoParts = Boolean(parts && parts?.length === 2);
    first = isTwoParts ? parts[0] : htmlContent;
    second = isTwoParts ? parts[1] : undefined;
    isArray = false;
  }

  return { first, second, isTwoParts, isArray };
};
